module.exports = __webpack_public_path__ + "static/media/Construction Suppliers Association Logo.5a65009c.png";